import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { cashdeskSchema } from '../types';

export type EditCashdeskMutationParams = {
	id: number;
	name: string;
	cashierIds: number[];
	fastDeposits: number[];
	note?: string;
};

export const createEditCashdeskMutation = () =>
	createAuthMutation({
		params: declareParams<EditCashdeskMutationParams>(),
		request: {
			method: 'PATCH',
			url: ({ id }) => `/cashdesk/${id}`,
			body: ({ id, ...params }) => params,
		},
		response: {
			contract: zodContract(cashdeskSchema),
		},
	});
